import { getLogger } from "Services/LoggingService";

export const logger = getLogger("Call Controls Panel");
export const dialpadLogger = getLogger("Twilio Conversations");
export const networkQualityLogger = getLogger("Network Quality Monitor");
